import React from 'react'

const CartItem = ({ product, productInfo, handleRemove, handleClick  }) => {
  return (
    <div className="shopping-cart-item" key={product.labelId}>
    <div>
    <img
      src={product.labelPNG}
      alt="preview"
      // style={{ width: "147px", height: "200px" }}
    />
    </div>
    <div className="product-information">
      <img
        src={productInfo ? productInfo.image : ""}
        alt={product.name}
      // style={{ width: "147px", height: "200px" }}
      />
    <div className="shopping-cart-info">
        <p className="shopping-product-name">
          {productInfo ? productInfo.name : ""}
        </p>
        <p className="shopping-product-price">
          Unit Price: ${productInfo ? productInfo.price : ""}
        </p>
        <button
          className="button is-danger is-small is-light"
          onClick={() => handleRemove(product.labelId)}
        >
          <span>Remove</span>
        </button>
    </div>
    </div>
    <div className="shopping-cart-quantity-change">
      <a
        onClick={(e) =>
          handleClick("down", product.labelId, product.quantity)
        }
        disabled={product.quantity === 0}
      >
        -
      </a>

      {product.quantity}
      <a
        onClick={(e) =>
          handleClick("up", product.labelId, product.quantity)
        }
      >
        +
      </a>
    </div>
    <div className="shopping-product-subtotal">
      <p>
        $
        {productInfo ? productInfo.price * product.quantity : 0}
      </p>
    </div>
  </div>
  )
}

export default CartItem
